// extracted by mini-css-extract-plugin
export default {"content":"Form_content__18MdL","wrapper":"Form_wrapper__NZliF","form":"Form_form__GvP9i","form__content":"Form_form__content__LiKO3","controls":"Form_controls__2m6x5"};